module.exports = __webpack_public_path__ + "img/a29fa12ae94bc378c0d9d464498168e7.png";